import React from 'react'
import { Popover, WithPopover } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { SearchableUserList } from '../../../shared/SearchableUserList'
import {
  useSoldByMenuItemModel,
  SoldByMenuItemProps,
} from './useSoldByMenuItemModel'

/**
 * This component renders a menu item that allows the user to bulk change the "sold by" user for all sale items.
 * When clicked, it opens a popover containing a searchable list of users to select from.
 * @param props
 * @returns
 */
export const SoldByMenuItem = (props: SoldByMenuItemProps) => {
  const t = useT()
  const model = useSoldByMenuItemModel(props)

  return (
    <WithPopover className="vd-popover--with-list" direction="left">
      <span
        className={`vd-popover-list-item ${
          model.isDisabled ? 'wr-more-actions-disabled' : ''
        }`}
        data-track="sales-person-select"
        onClick={model.isDisabled ? undefined : model.showPopover}
      >
        {t('Assign all sale items', {
          _context: 'Bulk change sold by menu item',
        })}
      </span>

      {model.isPopoverOpen && (
        <Popover
          onClose={model.hidePopover}
          className="sales-person-popover-container"
        >
          <SearchableUserList
            users={model.users}
            activeUserId={model.selectedUser?.id}
            onSelectHandler={model.onSelectHandler}
          />
        </Popover>
      )}
    </WithPopover>
  )
}
